import { StyleSheet, Image, ImageSourcePropType } from 'react-native'
import { DS } from '../../design-system'
import { TouchableOpacity } from 'react-native-gesture-handler'

interface CreateGameCardProps {
  title: string
  items: string[]
  image: ImageSourcePropType
  onPress: () => void
}

export const CreateGameCard = ({ title, items, image, onPress }: CreateGameCardProps) => {
  return (
    <TouchableOpacity onPress={onPress}>
      <DS.Frame style={styles.container}>
        <DS.Text variant="Heading 2/Medium" color="Global/Black">
          {title}
        </DS.Text>
        <DS.Frame gap="16">
          <DS.Frame style={styles.body}>
            <DS.Frame flex={1}>
              {items.map((text, index) => (
                <DS.Frame key={`create-game-card-item-${index}`} style={styles.textItem}>
                  <DS.Text variant="Caption/Regular" color="Global/Black">
                    •
                  </DS.Text>
                  <DS.Text variant="Caption/Regular" color="Global/Black">
                    {text}
                  </DS.Text>
                </DS.Frame>
              ))}
            </DS.Frame>
            <TouchableOpacity onPress={onPress}>
              <DS.Icon name="Arrow--right-enclosed" size={48} color="Global/Black" />
            </TouchableOpacity>
          </DS.Frame>
          <Image source={image} style={styles.image} />
        </DS.Frame>
      </DS.Frame>
    </TouchableOpacity>
  )
}

export const styles = StyleSheet.create({
  container: {
    backgroundColor: DS.palette['Global/White'],
    borderRadius: 16,
    padding: 16,
    gap: 8
  },
  textItem: {
    flexDirection: 'row',
    alignContent: 'flex-start',
    gap: 8
  },
  body: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: 16
  },
  image: { resizeMode: 'contain', height: 120, width: 'auto' }
})
